module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_5010.8854e39b.png";